import type { AssetsSegmentSchemaPatched } from '@iconik-io/iconik-api/src/schema_patched/assets_segments';
import {
  type AssetsHttpPostAssetsByAssetIdSegmentsHeader,
  type AssetsSegmentSchema,
  httpPatchAssetsByAssetIdSegmentsBySegmentId,
  httpPostAssetsByAssetIdSegments,
} from '@iconik-io/iconik-api/src/services/assets';

export const SEGMENT_STATUS_AWAITED: string = 'AWAITED';

/**
 * A comment is created as an AWAITED draft so attachments can reference it
 * before it is sent. The list endpoint never returns drafts, but a draft still
 * reaches the store through its create response and through websocket messages.
 */
export const isAwaitedSegment = (segment: { status?: string | null }) =>
  segment.status === SEGMENT_STATUS_AWAITED;

export const postDraftCommentRequest = (
  assetId: string,
  body: AssetsSegmentSchemaPatched,
  headers?: AssetsHttpPostAssetsByAssetIdSegmentsHeader,
) =>
  httpPostAssetsByAssetIdSegments(
    assetId,
    // biome-ignore lint/plugin: the generated segment status doesn't list AWAITED yet (TODO BE-4012 in schema_patched/assets_segments.ts).
    { ...body, status: SEGMENT_STATUS_AWAITED } as AssetsSegmentSchema,
    headers,
  );

/**
 * Sends a comment whose AWAITED draft already holds its attachments: the draft
 * takes the final content and turns ACTIVE instead of a second comment being
 * created.
 */
export function activateDraftCommentRequest(
  assetId: string,
  draftSegmentId: string,
  segment: AssetsSegmentSchemaPatched,
) {
  const { segment_type, asset_id, attachments, has_attachments, ...content } =
    segment;
  return httpPatchAssetsByAssetIdSegmentsBySegmentId(
    assetId,
    draftSegmentId,
    { ...content, status: 'ACTIVE' },
    { index_immediately: 'true' },
  );
}
